if (window.customElements)
{
  const scriptElem = document.createElement('SCRIPT');
  scriptElem.attributes['src'] = "/_nuxt/webcomponents/custom-elements-es5-adapter.js";
  document.body.appendChild(scriptElem)
}
